<template>
  <div class="md-layout page-offering">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Offering") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Flight Review General Settings") }}</h4>
          </div>
        </md-card-header>
        <md-card-content class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-90">
            <validated-dropdown-input
              :options="schools"
              v-model="reviewAddress.flight_schools"
              :label="
                $t(
                  'Flight School(s) - Choose the flight school(s) you are affiliated with'
                )
              "
              name="flightschool"
              validation-rules="required"
              :disabled="generalSettingStatus === 'detail'"
              :multiselect="true"
              :valueTransformation="item => item.FlightSchoolName"
              :displayTransformation="item => item.FlightSchoolName"
            />
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-radio
              :disabled="generalSettingStatus === 'detail'"
              v-model="reviewAddress.address_customized"
              :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO"
              >{{ $t("Address") }}</md-radio
            >
            <md-radio
              :disabled="generalSettingStatus === 'detail'"
              v-model="reviewAddress.address_customized"
              :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED"
              >{{ $t("GPS Coordinates") }}</md-radio
            >
            <md-radio
              v-if="pilot_network !== PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER"
              :disabled="generalSettingStatus === 'detail'"
              v-model="reviewAddress.address_customized"
              :value="FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB"
              >MAAC Club</md-radio
            >
          </div>

          <div
            v-show="isClub"
            class="md-layout-item md-small-size-100 md-size-90"
          >
            <validated-dropdown-input
              :options="clubs"
              v-model="reviewAddress.club_id"
              :label="$t('MAAC Club')"
              name="club"
              :validation-rules="{
                required: isClub ? true : false
              }"
              :disabled="generalSettingStatus === 'detail'"
              :valueTransformation="item => item._id.$oid"
              :displayTransformation="item => item.club_name"
              @input="onClubeChange"
            />
          </div>

          <template v-if="isClub && reviewAddress.club_id">
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-text-input
                :disabled="true"
                :label="$t('City')"
                name="city"
                v-model="reviewClubAddress.review_city"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-autocomplete-input
                :disabled="true"
                :label="$t('Province')"
                name="province"
                v-model="reviewClubAddress.review_province"
                :options="provinces"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-text-input
                :disabled="true"
                :label="$t('Postal Code')"
                name="postalcode"
                v-model="reviewClubAddress.review_postalcode"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-30"></div>
            <div class="md-layout-item md-small-size-100 md-size-30">
              <validated-text-input
                :disabled="true"
                :label="$t('latitude')"
                name="latitude"
                v-model="reviewClubAddress.latitude"
                @blur="longitudeOrlatitudeBlur"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-30">
              <validated-text-input
                :disabled="true"
                :label="$t('longitude')"
                name="longitude"
                v-model="reviewClubAddress.longitude"
                @blur="longitudeOrlatitudeBlur"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <validated-autocomplete-input
                :disabled="true"
                :label="$t('timezone')"
                name="timezone"
                v-model="reviewClubAddress.review_timezone"
                :options="CanadaTimezones"
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-90">
              <validated-text-input
                :disabled="true"
                :label="$t('Flight Review Address description')"
                name="street description"
                v-model="reviewClubAddress.review_street_desc"
              />
            </div>
          </template>

          <div
            v-show="isAuto"
            class="md-layout-item md-small-size-100 md-size-30"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail'"
              :label="$t('Flight Review Address')"
              name="street"
              v-model="reviewAddress.review_street"
              :validation-rules="{
                required: isAuto ? true : false,
                regex: /^.{6,}$/
              }"
            />
          </div>
          <div
            v-show="isAuto || isCustomized"
            class="md-layout-item md-small-size-100 md-size-20"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('City')"
              name="city"
              v-model="reviewAddress.review_city"
              :validation-rules="{
                required: !!(isAuto || isCustomized),
                regex: /^.{3,}$/
              }"
            />
          </div>
          <div
            v-show="isAuto || isCustomized"
            class="md-layout-item md-small-size-100 md-size-20"
          >
            <validated-autocomplete-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('Province')"
              name="province"
              v-model="reviewAddress.review_province"
              :options="provinces"
              :validation-rules="{
                required: !!(isAuto || isCustomized),
                regex: /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/
              }"
            />
          </div>
          <div
            v-show="isAuto || isCustomized"
            class="md-layout-item md-small-size-100 md-size-20"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('Postal Code')"
              name="postalcode"
              v-model="reviewAddress.review_postalcode"
              :validation-rules="{
                required: !!(isAuto || isCustomized),
                regex: /^([A-Z][0-9][A-Z] [0-9][A-Z][0-9])$/
              }"
              mask="A#A #A#"
            />
          </div>
          <div
            v-show="isCustomized"
            class="md-layout-item md-small-size-100 md-size-30"
          ></div>
          <div
            v-show="isCustomized"
            class="md-layout-item md-small-size-100 md-size-30"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('latitude')"
              name="latitude"
              v-model="reviewAddress.latitude"
              :validation-rules="{
                required: isCustomized ? true : false
              }"
              @blur="longitudeOrlatitudeBlur"
            />
          </div>
          <div
            v-show="isCustomized"
            class="md-layout-item md-small-size-100 md-size-30"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('longitude')"
              name="longitude"
              v-model="reviewAddress.longitude"
              :validation-rules="{
                required: isCustomized ? true : false
              }"
              @blur="longitudeOrlatitudeBlur"
            />
          </div>
          <div
            :style="`visibility: ${isCustomized ? 'visible' : 'hidden'}`"
            class="md-layout-item md-small-size-100 md-size-40"
          >
            <validated-autocomplete-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('timezone')"
              name="timezone"
              v-model="reviewAddress.review_timezone"
              :options="CanadaTimezones"
              :validation-rules="{
                required: isCustomized ? true : false
              }"
            />
          </div>
          <div
            v-show="isCustomized"
            class="md-layout-item md-small-size-100 md-size-90"
          >
            <validated-text-input
              :disabled="generalSettingStatus === 'detail' || isClub"
              :label="$t('Flight Review Address description')"
              name="street description"
              v-model="reviewAddress.review_street_desc"
              :validation-rules="{
                required: isCustomized ? true : false,
                regex: /^.{2,49}$/
              }"
            />
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-button
              v-if="generalSettingStatus === 'edit'"
              class="md-raised mt-4 mr-10"
              @click="cancelReviewAddress"
            >
              {{ $t("Cancel") }}
            </md-button>

            <md-button
              :disabled="btnLoading"
              class="md-raised md-primary mt-4"
              @click="updateReviewAddress"
            >
              {{
                generalSettingStatus === "detail"
                  ? $t("Edit Settings")
                  : generalSettingStatus === "edit"
                  ? $t("Update Settings")
                  : $t("Save Settings")
              }}
            </md-button>
          </div>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Flight Review Offering") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div>
            <md-checkbox value="flightTraining" disabled>{{
              $t("Flight Training (coming soon)")
            }}</md-checkbox>
          </div>
          <div>
            <md-radio
              v-model="isFlightReview"
              :value="isFlightReview || undefined"
              >{{ $t("Flight Review") }}</md-radio
            >
          </div>
          <div v-if="isFlightReview" class="md-layout-item md-size-60">
            <validated-text-input
              :label="$t('Flight Review Price') + ' ($)'"
              name="Flight Review Price"
              v-model="reviewPackage.price"
              :validation-rules="
                `required|between:${reviewerPriceMin},${reviewerPriceMax}`
              "
              type="number"
              :disabled="offeringStatus === 'detail'"
            />

            <div v-show="offeringStatus !== 'detail'">
              <md-checkbox v-model="tncAim" @change="changeState">{{
                $t("I agree to")
              }}</md-checkbox>
              <a
                style="margin-left: -20px; vertical-align: super;"
                href="/#/reviewerTnc"
                target="_blank"
                >{{
                  $t(
                    "RPAS Wilco Flight Review Terms and Conditions for Flight Reviewers"
                  )
                }}</a
              >
            </div>
            <div
              v-if="showError"
              class="md-layout-item md-size-100 text-danger"
            >
              {{ $t("You need to accept Terms & Conditions to continue.") }}
            </div>

            <div>
              <md-button
                v-if="offeringStatus === 'edit'"
                class="md-raised mt-4 mr-10"
                @click="offeringStatus = 'detail'"
              >
                {{ $t("Cancel") }}
              </md-button>

              <md-button
                :disabled="!reviewPackage.price || errors.any() || btnLoading"
                class="md-raised md-primary mt-4"
                @click="updatePrice"
              >
                {{
                  offeringStatus === "detail"
                    ? this.$t("Edit offering")
                    : offeringStatus === "edit"
                    ? this.$t("Update offering")
                    : this.$t("Save offering")
                }}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <AvailableTimeSetting />
    </div>
  </div>
</template>

<script>
import "vue2-timepicker/dist/VueTimepicker.css";
import {
  getMyPackageList,
  addPackage,
  updatePackage,
  updateReviewAddress,
  getFlightSchool,
  searchTimeZone,
  findClubs
} from "@/services/flightReview.service.js";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInputBrief.vue";
import ValidatedAutocompleteInput from "@/components/Inputs/ValidatedAutocompleteInput.vue";
import ValidatedDropdownInput from "@/components/Inputs/ValidatedDropdownInputBrief.vue";
import AvailableTimeSetting from "./AvailableTimeSetting.vue";
import {
  provinces,
  REVIEWER_PRICE_MIN,
  REVIEWER_PRICE_MAX,
  CanadaTimezones,
  FLIGHT_REVIEW_ADDRESS,
  PILOT_NETWORK
} from "@/const.js";
import { mapFields } from "vuex-map-fields";
import { EventBus } from "@/helpers";

export default {
  provide() {
    return {
      $validator: this.$validator
    };
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {
    ValidatedTextInput,
    ValidatedAutocompleteInput,
    ValidatedDropdownInput,
    AvailableTimeSetting
  },
  data() {
    return {
      reviewerPriceMin: REVIEWER_PRICE_MIN,
      reviewerPriceMax: REVIEWER_PRICE_MAX,
      PILOT_NETWORK,
      isFlightReview: false,
      offeringStatus: "add", // types: add | detail | edit
      generalSettingStatus: "add",
      btnLoading: false,
      reviewPackage: {
        price: ""
      },
      provinces,
      CanadaTimezones,
      tncAim: false,
      showError: false,
      schools: [],
      clubs: [],
      FLIGHT_REVIEW_ADDRESS,
      reviewAddress: {
        // flight review address
        review_street: "",
        review_city: "",
        review_province: "",
        review_postalcode: "",
        address_customized: FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO,
        review_street_desc: "",
        longitude: "",
        latitude: "",
        review_timezone: "",
        flight_schools: [],
        club_id: ""
      },
      reviewClubAddress: {
        review_city: "",
        review_province: "",
        review_postalcode: "",
        review_street_desc: "",
        longitude: "",
        latitude: "",
        review_timezone: ""
      }
    };
  },
  computed: {
    ...mapFields("auth", ["pilot_network"]),
    isAuto() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO
      );
    },
    isCustomized() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED
      );
    },
    isClub() {
      return (
        this.reviewAddress.address_customized ===
        FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB
      );
    }
  },
  async mounted() {
    this.loadReviewPackage();
    this.loadFlightSchool();
    this.loadClubs();
    this.initReviewerAddress();

    if (this.reviewAddress.review_postalcode) {
      this.generalSettingStatus = "detail";
    }

    EventBus.$on("getUserProfile", userInfo => {
      if (userInfo.review_postalcode) {
        this.generalSettingStatus = "detail";
        this.initReviewerAddress();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("getUserProfile");
  },
  methods: {
    async loadReviewPackage() {
      const myPackageList = await getMyPackageList();
      if (myPackageList.length > 0) {
        this.reviewPackage = myPackageList[0]; // default seeting, the first is flight review exam fee
        this.reviewPackage.id = this.reviewPackage._id.$oid;
        this.reviewPackage.price = (+this.reviewPackage.price / 100).toFixed(2);
        this.isFlightReview = true;
        this.offeringStatus = "detail";
      }
    },
    async loadFlightSchool() {
      this.schools = await getFlightSchool();
    },
    async loadClubs() {
      this.clubs = await findClubs();
    },
    updateReviewAddress() {
      switch (this.generalSettingStatus) {
        case "add":
        case "edit":
          this.$validator.validateAll().then(res => {
            if (res) {
              if (
                this.isCustomized &&
                CanadaTimezones.indexOf(this.reviewAddress.review_timezone) ===
                  -1
              ) {
                this.$notify({
                  message: this.$t("Please select the correct time zone."),
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning",
                  timeout: 3000
                });
                return;
              }

              this.btnLoading = true;
              const {
                review_street,
                review_city,
                review_province,
                review_postalcode,
                flight_schools,
                review_street_desc,
                address_customized,
                longitude,
                latitude,
                review_timezone,
                club_id
              } = this.reviewAddress;
              updateReviewAddress({
                review_street,
                review_city,
                review_province,
                review_postalcode,
                flight_schools,
                review_street_desc,
                address_customized,
                longitude,
                latitude,
                review_timezone,
                club_id
              })
                .then(() => {
                  this.$notify({
                    message: this.$t(
                      "Update flight review general settings successful"
                    ),
                    horizontalAlign: "center",
                    verticalAlign: "top",
                    type: "success",
                    timeout: 3000
                  });
                  this.generalSettingStatus = "detail";
                  this.$store.dispatch("auth/getUserProfile");
                })
                .finally(() => {
                  this.btnLoading = false;
                });
            }
          });
          break;

        case "detail":
          this.generalSettingStatus = "edit";
          break;
      }
    },
    cancelReviewAddress() {
      this.generalSettingStatus = "detail";
      this.initReviewerAddress();
    },
    updatePrice() {
      switch (this.offeringStatus) {
        case "add":
          if (!this.tncAim) {
            this.showError = true;
            return;
          }
          if (
            +this.reviewPackage.price < REVIEWER_PRICE_MIN ||
            +this.reviewPackage.price > REVIEWER_PRICE_MAX
          ) {
            return;
          }
          this.btnLoading = true;
          addPackage({
            title: this.$t("Flight Review"),
            description: this.$t("Flight Review"),
            price: +this.reviewPackage.price
          })
            .then(() => {
              this.$notify({
                message: this.$t("Add flight review package successful"),
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
                timeout: 3000
              });
              this.offeringStatus = "detail";
            })
            .finally(() => {
              this.btnLoading = false;
            });
          break;

        case "edit":
          if (!this.tncAim) {
            this.showError = true;
            return;
          }
          if (
            +this.reviewPackage.price < REVIEWER_PRICE_MIN ||
            +this.reviewPackage.price > REVIEWER_PRICE_MAX
          ) {
            return;
          }
          this.btnLoading = true;
          updatePackage({
            ...this.reviewPackage
          })
            .then(() => {
              this.$notify({
                message: this.$t("Edit flight review package successful"),
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
                timeout: 3000
              });
              this.offeringStatus = "detail";
            })
            .finally(() => {
              this.btnLoading = false;
            });
          break;
        case "detail":
          this.offeringStatus = "edit";
          break;
      }
    },
    changeState() {
      if (this.tncAim) {
        this.showError = false;
      }
    },
    longitudeOrlatitudeBlur() {
      if (this.latitude && this.longitude) {
        searchTimeZone(this.latitude, this.longitude).then(res => {
          this.reviewAddress.review_timezone = res;
        });
      }
    },
    onClubeChange(val) {
      const selectedObj = this.clubs.find(item => item._id.$oid === val);
      if (!selectedObj) return;
      const {
        latitude,
        longitude,
        review_city,
        review_postalcode,
        review_province,
        review_street_desc,
        _id,
        review_timezone
      } = selectedObj;
      this.reviewClubAddress = {
        review_city,
        review_province,
        review_postalcode,
        review_street_desc,
        longitude,
        latitude,
        review_timezone
      };
      this.reviewAddress.club_id = _id.$oid;
    },
    initReviewerAddress(addressobj = this.$store.state.auth) {
      Object.keys(this.reviewAddress).forEach(key => {
        this.reviewAddress[key] = addressobj[key] || "";
      });
      this.reviewAddress = { ...this.reviewAddress };
      const clubInfo = addressobj.club_info;
      if (clubInfo) {
        Object.keys(this.reviewClubAddress).forEach(key => {
          this.reviewClubAddress[key] = clubInfo[key] || "";
        });
        this.reviewClubAddress = { ...this.reviewClubAddress };
      }
    }
  }
};
</script>

<style lang="css">
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.mt-10 {
  margin-top: 10px;
}

.page-offering {
  .md-checkbox {
    z-index: 0;
  }

  .vue__time-picker .dropdown ul li:not([disabled]).active {
    background: #0abab5;
  }

  .md-disabled .md-checkbox-label,
  .md-disabled .md-checkbox-container,
  .md-checked.md-disabled .md-checkbox-container,
  .md-radio.md-disabled .md-radio-label,
  .md-radio.md-disabled .md-radio-container {
    opacity: 1;
    cursor: not-allowed;
  }
  .vue__time-picker input.display-time.disabled,
  .vue__time-picker input.display-time:disabled {
    color: #000;
  }
}
</style>
